module.exports = __webpack_public_path__ + "grape_app-dd06e.svg";